import { Pressable, View } from "react-native";
import { Text } from "@src/components";
import { Icon, IconProps } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";

export interface SettingsListItemProps {
  /** Item label text */
  title: string;
  /** Optional subtitle text shown below the title */
  subtitle?: string;
  /** Handler called when item is pressed */
  onPress: () => void;
  /** Whether to show the chevron icon (default: true) */
  showChevron?: boolean;
  /** Icon to use for the chevron (default: "chevronRight") */
  chevronIcon?: IconProps["name"];
}

export function SettingsListItem({
  title,
  subtitle,
  onPress,
  showChevron = true,
  chevronIcon = "chevronRight",
}: SettingsListItemProps) {
  const { theme } = useUnistyles();

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => ({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingVertical: theme.spacing["3xl"],
        paddingHorizontal: theme.spacing.xl,
        backgroundColor: pressed ? theme.colors.muted : theme.colors.surfaceCard,
        borderWidth: 1,
        borderColor: theme.colors.borderCard,
        borderRadius: theme.spacing.md,
        minHeight: 56,
        opacity: pressed ? 0.9 : 1,
        cursor: "pointer",
      })}
    >
      <View style={{ flex: 1 }}>
        <Text textStyle="sm/regular" color="text">
          {title}
        </Text>
        {subtitle && (
          <Text textStyle="xs/regular" color="textMuted">
            {subtitle}
          </Text>
        )}
      </View>
      {showChevron && <Icon name={chevronIcon} size={theme.spacing["6xl"]} color={theme.colors.textMuted} />}
    </Pressable>
  );
}
